import React from 'react';
import SectionInfoBox from '../../../components/SectionInfoBox';

interface AboutProjectProps {
    project: any;
    isDescriptionExpanded: boolean;
    setIsDescriptionExpanded: (expanded: boolean) => void;
}

const AboutProject: React.FC<AboutProjectProps> = ({ project, isDescriptionExpanded, setIsDescriptionExpanded }) => {
    return (
        <div id="about-project" className="card border border-gray-200 shadow-sm rounded-2xl mb-4 overflow-hidden scroll-mt-32">
            <div className="bg-white py-4 px-6 md:px-8 border-b border-gray-100 flex items-center gap-2">
                <h4 className="text-[21px] mb-0 font-black bg-clip-text text-transparent bg-gradient-to-r from-[#05144b] to-[#4c1d95] tracking-tight">About Project</h4>
                <SectionInfoBox text={project.sectionInfo?.about} />
            </div>
            <div className="p-6">
                <div className={`text-black text-[17px] font-normal leading-relaxed transition-all duration-300 ${!isDescriptionExpanded ? 'line-clamp-4 overflow-hidden' : ''}`}>
                        <p className="mb-4 font-black text-[19px] text-[#05144b] leading-tight italic opacity-90">
                            "{project.shortDescription}"
                        </p>
                    {project.description ? (
                        <div 
                            dangerouslySetInnerHTML={{ __html: project.description }} 
                            className="space-y-4"
                        />
                    ) : (
                        <p className="mb-0 text-gray-500 italic">
                            {!project.shortDescription && 'No project overview available at this moment.'}
                        </p>
                    )}
                </div>
                <button
                    onClick={() => setIsDescriptionExpanded(!isDescriptionExpanded)}
                    className="mt-4 text-[#05144b] font-black text-sm hover:underline flex items-center gap-1 group transition-colors"
                >
                    {isDescriptionExpanded ? (
                        <>Show Less <i className="fa-solid fa-chevron-up text-[10px] transform group-hover:-translate-y-0.5 transition-transform"></i></>
                    ) : (
                        <>Read More <i className="fa-solid fa-chevron-down text-[10px] transform group-hover:translate-y-0.5 transition-transform"></i></>
                    )}
                </button>
            </div>
        </div>
    );
};

export default AboutProject;
